<div
  class="table-responsive"
  [ngClass]="{
    'overflow-hidden': !collectionSize(),
    resizing: isResizing(),
  }"
  #table
>
  <table
    coreTableEllipsis
    class="table position-relative table-row-bordered table-row-gray-100 align-middle gs-0 gy-3"
    [style.tableLayout]="'fixed'"
  >
    <thead>
      @if (isDraggable()) {
        <tr
          cdkDropList
          #uploadContainer
          [cdkDropListOrientation]="'horizontal'"
          (cdkDropListDropped)="drop($event)"
          class="fw-bolder text-muted"
        >
          @for (
            column of columns();
            track column;
            let index = $index;
            let last = $last
          ) {
            @if (!last) {
              <th
                cdkDrag
                [cdkDragBoundary]="uploadContainer"
                [class.text-end]="last"
                [class]="column?.class"
                [ngStyle]="getColumnStyle(index)"
              >
                <div
                  class="column-header-content"
                  [ngClass]="{
                    'd-flex justify-content-end': last,
                  }"
                >
                  <ui-sortable-header
                    [column]="column"
                    [t]="t()"
                    [last]="last"
                    [sortField]="sortField"
                    [sortOrder]="sortOrder"
                    (sortChanged)="onSortChanged($event)"
                  ></ui-sortable-header>
                </div>

                <ui-resize-handler
                  [columnIndex]="index"
                  (resizeStart)="onResizeStart()"
                  (resizeMove)="onResizeMove($event)"
                  (resizeEnd)="onResizeEnd()"
                ></ui-resize-handler>
              </th>
            } @else {
              <th
                [class.text-end]="last"
                [class]="column?.class"
                [ngStyle]="getColumnStyle(index)"
              >
                <div
                  class="column-header-content"
                  [ngClass]="{
                    'd-flex justify-content-end': last,
                  }"
                >
                  <ui-sortable-header
                    [column]="column"
                    [t]="t()"
                    [last]="last"
                    [sortField]="sortField"
                    [sortOrder]="sortOrder"
                    (sortChanged)="onSortChanged($event)"
                  ></ui-sortable-header>
                </div>
              </th>
            }
          }
        </tr>
      } @else {
        <tr class="fw-bolder text-muted">
          @for (
            column of columns();
            track column;
            let index = $index;
            let last = $last
          ) {
            <th
              [class.text-end]="last"
              [class]="column?.class"
              [ngStyle]="getColumnStyle(index)"
            >
              <div
                class="column-header-content"
                [ngClass]="{
                  'd-flex justify-content-end': last,
                }"
              >
                <ui-sortable-header
                  [column]="column"
                  [t]="t()"
                  [last]="last"
                  [sortField]="sortField"
                  [sortOrder]="sortOrder"
                  (sortChanged)="onSortChanged($event)"
                ></ui-sortable-header>
              </div>

              @if (!last) {
                <ui-resize-handler
                  [columnIndex]="index"
                  (resizeStart)="onResizeStart()"
                  (resizeMove)="onResizeMove($event)"
                  (resizeEnd)="onResizeEnd()"
                ></ui-resize-handler>
              }
            </th>
          }
        </tr>
      }
    </thead>
    <tbody>
      <ng-content></ng-content>
    </tbody>
  </table>
</div>
@if (!collectionSize()) {
  <p *transloco="let t; prefix: 'uiKit'" class="text-xl text-center mt-2">
    {{ t('placeholders.noResults') }}.
  </p>
}
@if (collectionSize()) {
  <ui-form-pagination
    [collectionSize]="collectionSize()"
    [page]="page()"
    [pageSize]="pageSize()"
    (paginationValue)="paginationValue.emit($event)"
  ></ui-form-pagination>
}
